import { generateElementID } from '../../../../../../utils/generateElementID'
import { booleanToDayNameMap } from '../../../../../inputs/WeeklyDayPicker/WeeklyDayPicker'

// constants
export const DATE_PERIOD = 'date_period'
export const DAYS_OF_WEEK = 'days_of_week'
export const TIME_PERIODS = 'time_periods'
export const FROM = 'from'
export const TO = 'to'
export const DEFAULT_TIME_00 = '00:00:00'
export const TIME_24 = '24:00:00'

export interface PluginSchedule {
    element_id: string;
    [DATE_PERIOD]: {
        from: string | null
        to: string | null
    };
    [DAYS_OF_WEEK]: {
        is_monday: boolean
        is_tuesday: boolean
        is_wednesday: boolean
        is_thursday: boolean
        is_friday: boolean
        is_saturday: boolean
        is_sunday: boolean
    };
    [TIME_PERIODS]: Array<TimePeriod>
}

export function createPluginSchedule() {
    return {
        [DATE_PERIOD]: { [FROM]: null, [TO]: null },
        [DAYS_OF_WEEK]: {
            is_monday: true,
            is_tuesday: true,
            is_wednesday: true,
            is_thursday: true,
            is_friday: true,
            is_saturday: true,
            is_sunday: true,
        },
        [TIME_PERIODS]: [
            {
                [FROM]: DEFAULT_TIME_00,
                [TO]: DEFAULT_TIME_00,
                element_id: generateElementID(),
            },
        ],
        element_id: generateElementID()
    }

}

export interface TimePeriod {
    [FROM]: string | null;
    [TO]: string | null
    element_id: string
}

export function generateTimePeriod(from: string | null =  DEFAULT_TIME_00, to: string | null = DEFAULT_TIME_00) {
    return {
        [FROM]: from,
        [TO]: to,
        element_id: generateElementID(),
    }
}

export function generateJobScheduleSummary(schedule: PluginSchedule, isRuleActive?: boolean) {
    if (isRuleActive === false)
        return 'Schedule does not work while profile is inactive'

    const dateFromSummary = schedule.date_period.from
        ? `from ${schedule.date_period.from}`
        : ''
    const dateToSummary = schedule.date_period.to
        ? `to ${schedule.date_period.to}`
        : ''
    const days = Object.entries(schedule.days_of_week)
        .filter(([_, v]) => Boolean(v))
        // @ts-ignore
        .map(([k]) => booleanToDayNameMap[k])
    const daysSummary = days.length ? `every ${days.join(', ')}` : ''
    const timesSummary = schedule.time_periods?.length
        ? schedule.time_periods.map((timePeriod) => {
            const timeFrom = timePeriod.from || DEFAULT_TIME_00

            const timeTo =
                timePeriod.to === DEFAULT_TIME_00 || !timePeriod.to
                    ? TIME_24
                    : timePeriod.to

            return ` at ${timeFrom} - ${timeTo}`
        })
        : ` at ${DEFAULT_TIME_00} - ${TIME_24}`

    const isNoSummary =
        !dateFromSummary && !dateToSummary && !daysSummary && !timesSummary
    const summary = `Schedule is active ${dateFromSummary} ${dateToSummary} ${daysSummary} ${timesSummary}`

    return !daysSummary || isNoSummary ? '' : summary
}